import { BaseModel } from "./_base.model";

export abstract class BaseMysqlModel extends BaseModel {
	abstract hasChanged(newModel: BaseMysqlModel): boolean

	abstract toDataBase(): any;
}